export enum CardType {
  OrdinaryCardBonliva = "OrdinaryCardBonliva",
  ReserveCardBonliva = "ReserveCardBonliva",
  OrdinaryCardWCC = "OrdinaryCardWCC",
  ReserveCardWCC = "ReserveCardWCC",
  OtherCard = "OtherCard"
}
